module.exports = __webpack_public_path__ + "static/media/twitter-logo.46f08179.png";